var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTabBarHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.035 1.33214L1 8.5V20.7C1 21.1418 1.35817 21.5 1.8 21.5H10.5V13.5H12.5V21.5H21.2C21.6418 21.5 22 21.1418 22 20.7V8.5L11.965 1.33214C11.6868 1.13345 11.3132 1.13345 11.035 1.33214Z",
    stroke: "#0E0D0D",
    strokeWidth: 1.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabBarHome);
export default __webpack_public_path__ + "static/media/TabBarHome.c63d36a1edd7600ee052ea17f9b1e85a.svg";
export { ForwardRef as ReactComponent };